import store from "./redux/store-redux"
import React from 'react';
import ReactDOM from 'react-dom/client';
import AppBS from "./AppBS";
import {Provider} from "react-redux";

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
        <Provider store={store}>
            <AppBS />
        </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals




